import { createSlice } from "@reduxjs/toolkit";
import reducers from "./reducers";
import {
  connectWallet,
  disconnectWallet,
  getNetworkInfo,
  hasRole,
} from "./wallet.actions";

const initialState = {
  connectedWallet: null,
  isWalletConnected: false,
  isWalletConnecting: false,

  // wallet chain info

  connectedChainId: null,
  isCorrectNetwork: false,
  isChainInfoLoading: false,
  isChainInfoLoaded: false,
  isChainInfoLoadingFailed: false,

  hasRoleGetting: false,
  hasRoleGettingSucceed: false,
  hasRoleGettingFailed: false,
  isAdmin: false,
};

const walletSlicer = createSlice({
  name: "wallet-slicer",

  initialState,
  reducers,
  extraReducers: {
    [connectWallet.pending]: (state) => {
      state.isWalletConnecting = true;
      state.isWalletConnected = false;
    },
    [connectWallet.fulfilled]: (state, action) => {
      state.isWalletConnecting = false;

      state.connectedWallet = action.payload.connectedWallet;
      state.isWalletConnected = true;
    },
    [connectWallet.rejected]: (state) => {
      state.isWalletConnecting = false;
    },

    [hasRole.pending]: (state) => {
      state.hasRoleGetting = true;
      state.hasRoleGettingFailed = false;
      state.hasRoleGettingSucceed = false;
    },
    [hasRole.fulfilled]: (state, action) => {
      state.hasRoleGetting = false;
      state.hasRoleGettingFailed = false;
      state.hasRoleGettingSucceed = true;
      state.isAdmin = action.payload;
    },
    [hasRole.rejected]: (state) => {
      state.hasRoleGetting = false;
      state.hasRoleGettingFailed = false;
      state.hasRoleGettingSucceed = true;
    },

    // network info handling
    [getNetworkInfo.pending]: (state, action) => {
      state.isChainInfoLoading = true;
      state.isChainInfoLoaded = false;
    },
    [getNetworkInfo.fulfilled]: (state, action) => {
      state.connectedChainId = action.payload.connectedChainId;
      state.isCorrectNetwork = action.payload.isCorrectNetwork;
      state.isChainInfoLoading = false;
      state.isChainInfoLoaded = true;
    },
    [getNetworkInfo.rejected]: (state, action) => {
      state.isChainInfoLoading = false;
      state.isChainInfoLoadingFailed = true;
    },

    [disconnectWallet.fulfilled]: (state, action) => {
      state.connectedWallet = null;
      state.isWalletConnected = false;
      state.hasRoleGetting = false;
      state.hasRoleGettingSucceed = false;
      state.hasRoleGettingFailed = false;
      state.isMinter = false;
    },
  },
});

export default walletSlicer.reducer;

export const { updateNetworkInfo, resetChainInfo } = walletSlicer.actions;
